module.exports = __webpack_public_path__ + "static/img/modal-error.7b5151d4.png";